<form name="loginForm" novalidate (ngSubmit)="forward()" autocomplete="off"
    [ngClass]="{'form-complete': isFormCompleted}">

    <mat-form-field class="w-100">
        <mat-label [ngClass]="{'active' : confirmationNo}" class="control-label">
            {{"copy.label.LOGIN.oldlogin.label"|copy|async}}
        </mat-label>
        <a class="helpiconInTextbox" tabindex="0"
            matTooltip="{{'copy.label.LOGIN.oldlogin.returnLoginHelp'|copy|async}}">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
        </a>
        <input matInput required type="text" name="login-old-conf" [(ngModel)]="confirmationNo" alphanum />
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label [ngClass]="{'active' : emailAddress}" class="control-label">
            {{"copy.label.LOGIN.oldlogin.email"|copy|async}}
        </mat-label>
        <a class="helpiconInTextbox" tabindex="0" matTooltip="{{'copy.label.LOGIN.oldlogin.emailHelp'|copy|async}}">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
        </a>
        <input matInput required type="text" name="login-old-email" [(ngModel)]="emailAddress" alphanum />
    </mat-form-field>
    <span class="help-block">
        <!-- <a ng-click="loginCtrl.openForgotConf()">{{"copy.label.LOGIN.oldlogin.forgot"|copy|async}}</a> -->
        <a tabindex="0" (click)="openForgotConf()"
            (keydown.enter)="openForgotConf()">{{"copy.label.LOGIN.oldlogin.forgot"|copy|async}}</a>
    </span>
    <div class="agreeCheckbox">
        <div class="checkboxFlexContainer">
            <mat-checkbox aria-labelledby="rememberme-label" name="rememberme" [(ngModel)]="rememberme"
                #RememberMe="ngModel"></mat-checkbox>
            <label id="rememberme-label">{{"copy.label.SUMMARY.rememberme"|copy|async}}
                <a tabindex="0" matTooltip="{{'copy.label.SUMMARY.remembermequestion'|copy|async}}">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                </a></label>
        </div>
    </div>
    <div class="button_group d-flex">
        <button type="submit" name="old-login-button" class="forward btn btn-primary" *ngIf="!isSubmitting">
            {{'copy.label.LOGIN.oldlogin.button'|copy|async}} </button>
        <button class="inputSubmit btn btn-primary ms-auto" *ngIf="isSubmitting">
            <i class="fas fa-spinner fa-spin"></i>
        </button>
    </div>

    <div *ngIf="errorMsg" type="danger">
        <strong>
            <span class="fas fa-stack">
                <i class="fas fa-exclamation fa-stack-1x"></i>
                <i class="far fa-circle fa-stack-2x"></i>
            </span>
            {{errorMsg}}
        </strong>
    </div>
</form>